<template>
  <div class="p-4">
    <h2>Detalhes da Análise #{{ $route.params.id }}</h2>

    <div v-if="loading">Carregando...</div>
    <div v-else-if="error">{{ error }}</div>

    <div v-else>
      <div class="details-meta mb-3">
        <p><b>Peso do prato:</b> {{ formatWeight(details.gross_sample_weight) }}</p>
        <p><b>% Avariados:</b> {{ formatPercent(details.total_damaged_percentage) }}</p>
      </div>

      <table class="table table-striped mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Categoria</th>
            <th>Peso (g)</th>
            <th>%</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in mappedDetails" :key="item.key">
            <td>{{ item.index }}</td>
            <td>{{ formatKey(item.key) }}</td>
            <td>{{ formatWeight(item.value.weight) }}</td>
            <td>{{ formatPercent(item.value.percentage) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { request } from '@/services'

const EXCLUDED_KEYS = new Set([
  'gross_sample_weight',
  'analysesId',
  'total_damaged',
  'total_damaged_percentage',
  'sadio'
])

export default {
  data () {
    return {
      details: null,
      loading: true,
      error: null
    }
  },
  computed: {
    mappedDetails () {
      if (!this.details) return []
      return Object.entries(this.details)
        .filter(([key]) => !EXCLUDED_KEYS.has(key) && !EXCLUDED_KEYS.has(key.toLowerCase()))
        .map(([key, value], index) => ({
          index: index + 1,
          key,
          value
        }))
    }
  },
  methods: {
    formatKey (key) {
      return key.replace(/_/g, ' ').replace(/\+/g, '+')
    },
    formatWeight (value) {
      if (value == null || value === '') return '---'
      const num = Number(String(value).replace(',', '.'))
      if (!Number.isFinite(num)) return String(value)
      return `${num.toFixed(2)} g`
    },
    formatPercent (value) {
      if (value == null || value === '') return '---'
      const num = Number(String(value).replace(',', '.'))
      if (!Number.isFinite(num)) return String(value)
      return `${num.toFixed(2)}%`
    }
  },
  async created () {
    const id = this.$route.params.id
    this.loading = true
    try {
      const res = await request.get(`/analyses/${id}/details`)
      this.details = res.data
    } catch (err) {
      console.error('Erro ao carregar detalhes da análise:', err)
      this.error = 'Erro ao carregar detalhes da análise.'
    } finally {
      this.loading = false
    }
  }
}
</script>
